import React, { PropsWithChildren } from 'react';
import clsx from 'clsx';

export type TabBarProps = {
  tabs: string[] | { label: string, icon?: React.ReactNode, disabled?: boolean }[];
  index: number;
  onChange: (index: number,) => void;
	className?: string;
};

export function TabBar({ tabs, index = 0, onChange, children, className }: PropsWithChildren<TabBarProps>) {
	return (
		<div className={clsx('flex border-b border-borders-primary pl-6 justify-between h-[40px]', className)}>
			<div className="flex gap-8">
				{tabs.map((def, i) => {
					const tab = typeof def === 'string' ? { label: def } : def;
					return (
						<button
							key={i}
							className={clsx(
								'flex-initial shrink-0 cursor-pointer align-middle text-sm font-medium transition-colors duration-100 flex items-center gap-2',
								'border-b-2 border-transparent text-text-secondary',
								'hover:text-fg-highlight hover:border-b-fg-highlight',
								'data-active:text-fg-highlight data-active:border-b-fg-highlight',
								'disabled:text-text-tertiary disabled:border-transparent disabled:hover:text-text-tertiary disabled:hover:border-transparent',
							)}
							data-active={index === i || undefined}
							onClick={() => onChange(i)}
							disabled={tab.disabled}
						>
							{tab.icon}
							{tab.label}
						</button>
					);
				})}
			</div>
			<div>
				{children}
			</div>
		</div>
	);
}
